var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEswatini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.64 71.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m2.13 44.33-.63-2 .13-5.19.63-3.3 1.39-4.3 1.92-2.15 1.81-2L9.15 23l1.07-1.88 1.57-1.52.48-1.91.74-2 .76-6h0l.64-1 .22-1.09V6.11l.16-1 .34-.45.53-.35.69-.45 2.12-1.15L20.25 2l2.16-.49h5.95v1.45l.1 1.64.26.16h1.71l5.23 4.89 2.65.1L40 11l.57.26 1.76.32 2.25 2 2.71.18 1.86.62 1.65.68.94.82.61.18.83.06.4.08-.09.59-.55 1 .06 1.37.76 2 .1 1.73-.23 3.05v3l.08 1.06.12.7.17.3v.44l-.45 1.24L53.2 34v.53l-.14.37-.27.33-1.19.61-.2.37v.68l.15.57.45.21.53.33.21.42v.46l-.17.83-.48 1.39.48 1.59.53 1 .73 1.2.31.74v.53l-.11.52-1.1 2.19-.79 1.37-1 1.46-1.28.92-.33.44-.13.5.05 1.1-.06 1.16-1.09 1.77L48.25 70l-9.47-.32-.78-.48-1.1-.36-1.41-.17-1.82.07-2.24.3-2.43-.36-2.57-1-2.14-.36-2.55.45h-.11l-.44-.34-.7-.75-1.16-.13-.33-.2-.26-.28-.17-.36-.07-.4.19-1.23-.09-.08-.31-.15-.64-.15-1.53-.55-1.93-.55-3.12-.6-1.22-.15-.28-.18-.35-.45-.6-1.41-.56-.93-1.35-1.47L6.5 57l.06-1.13.1-.92 2.93-1-.07-.72v-.91l.05-.6-.19-.26-.48-.19-1.39-.08H5.83l-.06-.91-.16-1.42-.33-.86-.39-.43-.77-.44-1.56-.6z",
    "data-name": "Layer 93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEswatini);
export default __webpack_public_path__ + "static/media/eswatini.8750504719e790a21a6c07fc0b4b75fa.svg";
export { ForwardRef as ReactComponent };